export default "__VITE_ASSET__CRVY$nOk__"